import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { SupportAgent } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function deleteSupportAgent(agent: SupportAgent) {
  return api.delete(`/support/agents/${agent.id}`).then(axiosSuccess).catch(axiosError);
}

export function useDeleteSupportAgent() {
  const queryClient = useQueryClient();

  return useMutation((agent: SupportAgent) => deleteSupportAgent(agent), {
    onSuccess: () => {
      handleRequestSuccess('Agente removido do rodízio com sucesso!');
      queryClient.invalidateQueries('support-agents');
      queryClient.invalidateQueries('support-stats');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao remover agente. Tente novamente.');
    },
  });
}
